import { useHasGate } from '../accounts';
export const useIsAcademyAssistantUngated = () => {
  const {
    hasGate,
    hasGateLoading,
    hasGateError
  } = useHasGate('Academy:AiAssistant');
  return {
    isAcademyAssistantUngated: hasGate,
    isAcademyAssistantUngatedLoading: hasGateLoading,
    isAcademyAssistantUngatedError: hasGateError
  };
};